import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm mt-8" }
const _hoisted_2 = { class: "px-6" }
const _hoisted_3 = { class: "grid gap-6" }
const _hoisted_4 = { class: "flex flex-col gap-1" }
const _hoisted_5 = ["aria-invalid"]
const _hoisted_6 = {
  key: 0,
  class: "text-destructive text-xs mt-1"
}
const _hoisted_7 = { class: "flex flex-col gap-1" }
const _hoisted_8 = ["aria-invalid"]
const _hoisted_9 = {
  key: 0,
  class: "text-destructive text-xs mt-1"
}
const _hoisted_10 = { class: "flex justify-end px-6" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 1 }

import { ref, watch } from 'vue'
import { Loader2 } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'GetStartedStep',
  props: {
    data: {},
    isSaving: { type: Boolean }
  },
  emits: ['update', 'next'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const localData = ref({ ...props.data })
const errors = ref<Record<string, string>>({})

watch(localData, (val) => emits('update', val), { deep: true })

const validateAndProceed = () => {
  const newErrors: Record<string, string> = {}

  if (!localData.value.companyName.trim()) {
    newErrors.companyName = 'Company name is required'
  }

  if (!localData.value.companyEmail.trim()) {
    newErrors.companyEmail = 'Email is required'
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(localData.value.companyEmail)) {
    newErrors.companyEmail = 'Please enter a valid email address'
  }

  errors.value = newErrors

  if (Object.keys(newErrors).length === 0) {
    emits('next')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6" }, [
      _createElementVNode("div", { class: "leading-none font-semibold text-lg" }, "Get Started"),
      _createElementVNode("div", { class: "text-muted-foreground text-sm" }, " Let's begin with some basic information ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "font-medium text-sm" }, "Company Name", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localData.value.companyName) = $event)),
            type: "text",
            placeholder: "Acme Mining Corp",
            class: "w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:border-brand focus:ring-1 focus:ring-brand outline-none",
            "aria-invalid": !!errors.value.companyName
          }, null, 8, _hoisted_5), [
            [_vModelText, localData.value.companyName]
          ]),
          (errors.value.companyName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errors.value.companyName), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { class: "font-medium text-sm" }, "Company Email", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localData.value.companyEmail) = $event)),
            type: "email",
            placeholder: "contact@acmemining.com",
            class: "w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:border-brand focus:ring-1 focus:ring-brand outline-none",
            "aria-invalid": !!errors.value.companyEmail
          }, null, 8, _hoisted_8), [
            [_vModelText, localData.value.companyEmail]
          ]),
          (errors.value.companyEmail)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errors.value.companyEmail), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "rounded-lg bg-muted/50 p-4 text-sm text-muted-foreground" }, " We'll use this to create your company record so you can continue your registration later if needed. ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-md bg-brand text-white text-sm font-medium flex items-center justify-center gap-2 hover:opacity-90 transition disabled:opacity-70 disabled:cursor-not-allowed",
        onClick: validateAndProceed,
        disabled: props.isSaving
      }, [
        (props.isSaving)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_unref(Loader2), { class: "w-4 h-4 animate-spin" }),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Saving...", -1))
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_12, "Next"))
      ], 8, _hoisted_11)
    ])
  ]))
}
}

})